/**
 * True when an editor-authored Builder `schemaJson` field actually holds
 * content. Builder seeds the field with an empty object `{}` (which is truthy),
 * so a plain `schemaJson || fallback` check never reaches the fallback and
 * emits an empty `<script>`. Treat empty objects / blank strings as absent so
 * generated schema can take over.
 */
const hasSchemaContent = (schema: unknown): boolean => {
  if (!schema) {
    return false;
  }
  if (typeof schema === 'string') {
    return schema.trim().length > 0;
  }
  if (typeof schema === 'object') {
    return Object.keys(schema as Record<string, unknown>).length > 0;
  }

  return false;
};

export default hasSchemaContent;
